import {Component, Vue} from "vue-property-decorator"
import {delNullProperty} from '@/utils/index'
import {formatDate} from '@/utils/timeFilter'
import {UserModule} from "@/store/modules/user";
import {getCustomerConversionFollowList, getCustomerConversionFollowListExport} from "@/api/customer";
import { menuBtn } from '@/utils/menu_level2_button'
@Component({})
export default class OrderStatisticsData extends Vue {
  page = 1
  limit = 20
  total = 0
  tableData = []
  tableLoading = false
  popover1 = false
  popover2 = false
  popover3 = false
  exportButtonDisabled = false
  createdAt = [] // 跟进时间
  customerConversionName = ''
  userIdList = []
  intentionality = ''
  intentionalityList =  [
    {label:'A',value:'A',interpretation:'（7天内签约）'},
    {label:'B',value:'B',interpretation:'（15天内签约）'},
    {label:'C',value:'C',interpretation:'（30天内签约）'},
    {label:'D',value:'D',interpretation:'（90天内签约）'},
    {label:'E',value:'E',interpretation:'（长期跟进）'},
    {label:'F',value:'F',interpretation:'（流失并调入公海）'},
    {label:'已签约',value:'已签约',interpretation:''},
  ]
  menuBtn = menuBtn
  timer = null


  get userList() {
    return UserModule.userList
  }

  created() {
    this.getTableData()
  }

  // 时间区间过滤器
  changeTime(val: Date[]): string {
    if (val == null) return ''
    let time = ''
    val.forEach((item: any) => {
      time += formatDate('yyyy-MM-dd', new Date(item)) + '&'
    })
    time = time.slice(0, time.length - 1)
    return time
  }
  //backMoneyAt: this.changeTime(this.backMoneyAt as Date[]), //回款时间


  async getTableData() {
    this.popover1 = false
    this.popover2 = false
    this.popover3 = false
    this.tableLoading = true

    const { allNum, customerConversionFollowList } = await getCustomerConversionFollowList(delNullProperty({
      customerConversionName: this.customerConversionName,
      userIdList: this.userIdList,
      createdAt: this.changeTime(this.createdAt),
      intentionality: this.intentionality,
      limit: this.limit,
      page: this.page,
    })) as unknown as { allNum: number; customerConversionFollowList: any[] }
    this.tableData = customerConversionFollowList
    this.total = allNum
    this.tableLoading = false

  }

  async exportExcel() {
    this.exportButtonDisabled = true
    this.$message.success('数据已转入后台导出, 请前往下载列表查看')
    await getCustomerConversionFollowListExport(delNullProperty({
          customerConversionName: this.customerConversionName,
          userIdList: this.userIdList,
          createdAt: this.changeTime(this.createdAt),
          intentionality: this.intentionality,
        })
    ).finally(() => {
      this.exportButtonDisabled = false
    })
  }

  pageSizeChange(limit: number) {
    this.limit = limit
    this.getTableData()
  }

  pageChange(page: number) {
    if (this.timer !== null) clearTimeout(this.timer)
    this.timer = setTimeout(() => {
      this.page = page
      this.getTableData()
    }, 1000)
  }

}
